<template>
    <div class="draggable-item-menu-container" @click.self="emitCloseMenu">
      <div class="draggable-item-menu">
        <span class="close-button mdi mdi-window-close" @click="emitCloseMenu"></span>
        <div class="draggable-item-menu-header">
            <h2>Menú de acciones</h2>
        </div>
        <div class="draggable-item-menu-content">
            <div class="order-reference-extra-context-row order-reference-state-context">
              <span :style="{ color: orderReferenceStateColor }">
                {{ orderReferenceStateDescription }}
              </span>
            </div>
            <ProductionOrderCardContent 
              :orderReference="orderReference"
              :isThereOrInProductionAtProductionLine="isThereOrInProductionAtProductionLine" 
              :canOpenMenu="false"
            />
            <div class="order-reference-extra-context">
              <div class="order-reference-minor-extra-content-row">
                <span  @click="copyToClipboard(orderReference.id)" class="clicable">
                    ID: {{ orderReference.id || 'ID N/A' }}
                </span>
                - 
                <span @click="copyToClipboard(orderReference.ext_pk)" class="clicable">
                    EXT_PK: {{ orderReference.ext_pk || 'Clave externa N/A' }}
                </span>
              </div>
            </div>
            <hr class="context-options-separator" />
            <ProductionOrderCardMenuOptions
                :orderReference="orderReference"
                :emitCloseMenu="emitCloseMenu"
                :isThereOrInProductionAtProductionLine="isThereOrInProductionAtProductionLine"
            />
        </div>
      </div>
    </div>
  </template>
  

<script>
import ProductionOrderCardContent from './ProductionOrderCardContent.vue';
import ProductionOrderCardMenuOptions from './ProductionOrderCardMenuOptions/ProductionOrderCardMenuOptions.vue';

export default {
    name: "ProductionOrderCardMenu",
    components: {
        ProductionOrderCardContent,
        ProductionOrderCardMenuOptions,
    },
    props: {
        orderReference: {
            type: Object,
            required: true,
        },
        isThereOrInProductionAtProductionLine: {
            type: Boolean,
            default: false
        },
        showMenu: {
            type: Boolean,
            default: false
        },
    },
    methods: {
        emitCloseMenu() {
            this.$emit('closeMenu');
        },
        copyToClipboard(text) 
        {
            navigator.clipboard.writeText(text).catch
            (err => 
                {
                    console.error('Error al copiar el texto: ', err);
                }
            );
        },
    },
    computed: {
        orderReferenceStateDescription() {
            let description = '';
            switch (this.orderReference.order_state_id) {
                case 1:
                    description = 'PENDIENTE';
                    break;
                case 2:
                    description = 'EN CURSO';
                    break;
                case 3:
                    description = 'FINALIZADO';
                    break;
                default:
                    description = 'DESCONOCIDO';
                    break;
            }
            if (this.orderReference.in_queue_date) {
                description += ' - EN COLA';
            }
            return description;
        },
        orderReferenceStateColor() {
            let color = '';
            switch (this.orderReference.order_state_id) {
                case 1:
                    color = 'red';
                    break;
                case 2:
                    color = 'blue';
                    break;
                case 3:
                    color = 'green';
                    break;
                default:
                    color = 'gray';
                    break;
            }
            if (this.orderReference.in_queue_date) {
                color = 'orange';
            }
            return color;
        },
    },
};
</script>
